<template>
  <div>
    <div class="custom-card">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-4 col-lg-4 col-12">
            <div class="picture-upload-form text-center">
              <div class="my-3">
                
                  <image-uploader :imageUrl="user.imageurl" @uploaded="onImageUploaded" @remove-image="removeImage"
                  :isUploadingImage="isUploadingImage" />

              </div>
            </div>
          </div>

          <div class="col-md-12 col-lg-12 col-12">
            <div class="input-row">
              <div class="new-user-form__single-input-wrapper">
                <label for="fname" class="label">First Name</label>
                <input type="text" class="input" v-model="user.firstname" placeholder="-- Enter First Name --" />
              </div>
              <div class="new-user-form__single-input-wrapper">
                <label for="mname" class="label">Middle Name</label>
                <input type="text" class="input" v-model="user.middlename" placeholder="-- Enter Middle Name --" />
              </div>
              <div class="new-user-form__single-input-wrapper">
                <label for="lname" class="label">Last Name</label>
                <input type="text" class="input" v-model="user.lastname" placeholder="-- Enter Last Name --" />
              </div>
            </div>

            <div class="input-row">
              <div class="new-user-form__single-input-wrapper">
                <label for="gender" class="label">Gender</label>
                <el-select v-model="user.gender" placeholder="-- Select --">
                  <el-option v-for="gender in genders" :key="gender" :label="gender" :value="gender">
                  </el-option>
                </el-select>
              </div>
              <div class="new-user-form__single-input-wrapper">
                <label for="email" class="label">Email Address</label>
                <input type="email" disabled class="input" v-model="user.email" />
              </div>
              <div class="new-user-form__single-input-wrapper">
                <label for="number" class="label">Phone Number</label>
                <vue-tel-input :preferredCountries="['Nigeria']" v-model="user.mobile_no"></vue-tel-input>
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr />

      <div class="container-fluid">
        <div class="row">
          <div class="col-md-4 col-lg-4 col-12">
            <h3>Contact Address</h3>
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-md-4 col-lg-4 col-12">
            <div class="new-user-form__single-input-wrapper">
              <label for="address" class="label">Address</label>
              <!-- <input type="text" class="input" v-model="user.lastname" placeholder="-- Enter address --" /> -->
             <input type="text" class="input" v-model="location.address" placeholder="-- Enter address --" />
              <!-- <vue-google-autocomplete id="map2" ref="shipperAddress" :value="location.address" classname="input"
                placeholder="Enter address" v-on:placechanged="getAddress">
              </vue-google-autocomplete> -->
            </div>
          </div>

          <div class="col-md-4 col-lg-4 col-12">
            <div class="new-user-form__single-input-wrapper">
              <label for="mname" class="label">Country</label>
              <!-- <input type="text" class="input" v-model="location.country" />    -->
              <el-select v-model="selectedCountry" value-key="isoCode" placeholder="-- Select Country --">
                  <el-option v-for="country in countries" :key="country.isoCode"  :label="country.name" :value="country">
                  </el-option>
              </el-select>
            </div>
          </div>

          <div class="col-md-4 col-lg-4 col-12">
            <div class="new-user-form__single-input-wrapper">
              <label for="gender" class="label">State</label>
              <!-- <input type="text" class="input" v-model="location.state" /> -->
              <el-select v-model="selectedState" value-key="isoCode" placeholder="-- Select State --" >
                  <el-option v-for="state in states" :key="state.isoCode" :label="state.name" :value="state">
                  </el-option>
              </el-select>
            </div>
          </div>

          <div class="col-md-4 col-lg-4 col-12">
            <div class="new-user-form__single-input-wrapper">
              <label for="lname" class="label">City</label>
              <!-- <input type="text" class="input" v-model="location.city" /> -->
              <el-select v-model="selectedCity" placeholder="-- Select City --">
                  <el-option v-for="city in cities" :key="city.name" :label="city.name" :value="city.name">
                  </el-option>
              </el-select>
            </div>
          </div>

        </div>

        <div class="row mt-3">
         
            <h3>Emergency Contact <span class="text-[#B7BDCD]">(Optional)</span></h3>
        
        </div>

        <div class="row mt-3">

          <div hidden class="col-md-4 col-lg-4 col-12">
            <div class="new-user-form__single-input-wrapper">
              <label for="fname" class="label">Security Question</label>
              <div class="d-flex modal-input">
                <input type="text" class="input" v-model="newUser.mname" />
                <span @click="showSecurityQuestionModal = true"><img src="@/assets/images/icons/edit.svg" alt=""></span>
              </div>
            </div>
          </div>

          <div class="col-md-4 col-lg-4 col-12">
            <div class="new-user-form__single-input-wrapper">
              <label for="fullname" class="label">Full Name</label>
              <input type="text" class="input" v-model="emergencyContact.fullName" placeholder="-- Enter First Name --" />
            </div>
          </div>
          
          <div class="col-md-4 col-lg-4 col-12">
            <div class="new-user-form__single-input-wrapper">
              <label for="address" class="label">Address</label>
              <input type="text" class="input" v-model="emergencyContact.address" placeholder="-- Enter address --" />
              <!-- <vue-google-autocomplete id="map2" ref="shipperAddress" :value="location.address" classname="input"
                placeholder="Enter address" v-on:placechanged="getAddress">
              </vue-google-autocomplete> -->
            </div>
          </div>

          <div class="col-md-4 col-lg-4 col-12">
            <div class="new-user-form__single-input-wrapper">
               <label for="number" class="label">Phone Number</label>
              <vue-tel-input :preferredCountries="['Nigeria']" v-model="emergencyContact.phoneNumber"></vue-tel-input>
            </div>
          </div>

          <div class="col-md-4 col-lg-4 col-12">
            <div  class="new-user-form__single-input-wrapper">
              <label for="relationship" class="label">Relationship</label>
              <el-select filterable  placeholder="Select"
                :disabled="!relationships.length" v-model="emergencyContact.relationship">
                <el-option v-for="relationship in relationships" :key="relationship"
                  :label="relationship" :value="relationship">
                </el-option>
              </el-select>
            </div>
          </div>

        </div>

        <div class="flex items-center my-4 justify-between">
          <div class="cursor-pointer" @click="$router.go(-1)">
            <p>Cancel</p>
          </div>
          <primary-button buttonText="Save" @click="updateUser" :loading="updatingUser" />
        </div>
      </div>
    </div>

    <update-password-modal :show-modal="showPasswordModal" @close-modal="showPasswordModal = false" />
    <password-policy-modal :show-modal="showPolicyModal" @close-modal="showPolicyModal = false" />
    <security-question-modal :show-modal="showSecurityQuestionModal" @close-modal="showSecurityQuestionModal = false" />
    <two-factor-modal :show-modal="showTwoFactorModal" @close-modal="showTwoFactorModal = false" />

  </div>
</template>

<script>
import { Country, State, City } from "country-state-city";
import { relationships } from "@/utilities/globalVariables";
// import VueGoogleAutocomplete from "vue-google-autocomplete";
import ImageUploader from "@/components/3pl/Users/ImageUploader";
import UpdatePasswordModal from "@/views/3pl/Settings/SecurityPolicy/Modals/UpdatePassordModal";
import SecurityQuestionModal from "@/views/3pl/Settings/SecurityPolicy/Modals/SecurityQuestionModal";
import TwoFactorModal from "@/views/3pl/Settings/SecurityPolicy/Modals/TwoFactorModal";
import PasswordPolicyModal from "@/views/3pl/Settings/SecurityPolicy/Modals/PasswordPolicyModal";
import timezones from "@/utilities/timezones";
export default {
  components: {
    ImageUploader,
    TwoFactorModal,
    SecurityQuestionModal,
    UpdatePasswordModal,
    PasswordPolicyModal,
    // VueGoogleAutocomplete
  },
  data() {
    return {
      relationships: relationships,
       emergencyContact: {
                address: "",
                fullName: "",
                phoneNumber: "",
                relationship: ""
            },
    
      location: {
        address: "",
        country: "",
        state: "",
        city: "",
      },
     
      countries: [],
      states: [],
      cities: [],
      selectedCountry: null,
      selectedState: null,
      selectedCity: null,

      showPolicyModal: false,
      showSecurityQuestionModal: false,
      showPasswordModal: false,
      showTwoFactorModal: false,
      timezones: timezones,
      newUser: {
        fname: "",
        mname: "",
        lname: "",
        gender: "",
        email: "",
        phoneNo: "",
        employmentType: "",
      },
      user: {
        firstname: "oba",
        middlename: "three",
        lastname: "pl",
        gender: "male",
        email: "thevetdoctor@gmail.com",
        hash: "5fd56c1fee8f10c161f9f14b536895062008f50b6b4d0ad45164cb80aca7ae8bc37e375d9c7ed1dd5deb8b6e400ed790b44fd6432089386e97730e3fce4d910d",
        salt: "6e930199a117a78a1090c8ac1510c110e9972e4c3e24f45568472f4309201c42",
        accounttype: "organization",
        image: null,
        imageurl: "https://cloudenly-primary.s3.eu-west-2.amazonaws.com/muleex/1630526780862-1626247746317.jpg",
        onboardingtype: "3PL",
        mobile_no: "08069100466",
        twoFA: null,
        securityques: null,
        answer: null,
        createdAt: "2021-08-24T19:31:07.409Z",
        updatedAt: "2021-10-13T10:15:59.754Z",
        passwordauth: null,
        Orgs: [
          {
            id: "a62faded-e513-41b9-b2f7-5f1c21d49bf8",
            userId: "7dea03b7-c2d6-4540-89b9-40119db6d81f",
            companyname: "updated organization name",
            customdomain: "obang",
            industry: "Agriculture",
            regnumber: "oba01",
            mobile_no: "0806 910 0463",
            email: "thevetdoctor@gmail.com",
            image: null,
            imageurl: "",
            specialization: "Agro-Allied Services",
            address: "updated organization address",
            city: null,
            country: null,
            type: null,
            stateId: null,
            twoFA: null,
            web: null,
            facebook: null,
            linkedin: null,
            twitter: null,
            instagram: null,
            createdAt: "2021-08-24T19:33:22.072Z",
            updatedAt: "2021-10-06T23:58:12.243Z"
          }
        ]
      },
      genders: ["Male", "Female"],
      languages: ["English"],
      employmentTypes: [
        "Full-time",
        "Part-time",
        "Intern",
        "Company-paid Temporary",
        "Independent Contractor",
        "Agency-paid Temporary",
        "Vendor Employee",
        "Volunteer",
      ],
      creatingUser: false,
      roles: [],
      selectedRoleId: '',
      isUploadingImage: false,
      updatingUser: false
    };
  },

  watch: {
    selectedCountry(newVal) {
      if (!newVal) {
        this.states = []
        this.cities = []
        return
      }

      this.states = State.getStatesOfCountry(newVal.isoCode)
      this.location.country = newVal.name
    },

   selectedState(newVal) {
    if (!newVal) {
      this.cities = []
      this.selectedCity = null
      return
    }
    this.cities = City.getCitiesOfState(
      this.selectedCountry.isoCode,
      newVal.isoCode
    )
    // Save actual name
    this.location.state = newVal.name
  },
     selectedCity(newVal) {
      if (!newVal) return
      this.location.city = newVal
    },
  },

  computed: {
    disableButton() {
      return this.shouldDisableButton(this.newUser);
    },

  },

  mounted() {
     this.countries = Country.getAllCountries();

  // Load user from localStorage anyway
  const loggedInUser = localStorage.getItem("loggedInUser");
  if (loggedInUser) {
    this.user = JSON.parse(loggedInUser);

    // Populate address fields
    if (this.user.address) { 
      this.location = {
        address: this.user.address.name || '',
        lat: this.user.address.lat || '',
        long: this.user.address.lng || '',
        city: this.user.address.adm_1 || '',
        state: this.user.address.adm_2 || '',
        country: this.user.address.country || ''
      };
       // ✅ STEP 1: Set selectedCountry properly (OBJECT, not string)
      this.selectedCountry = this.countries.find(
        c => c.name === this.location.country
      );

      // ✅ STEP 2: Load states immediately
      if (this.selectedCountry) {
        this.states = State.getStatesOfCountry(this.selectedCountry.isoCode);

        // ✅ STEP 3: Set selectedState properly
        this.selectedState = this.states.find(
          s => s.name === this.location.state
        );
      }
      // ✅ STEP 4: Load cities immediately
      if (this.selectedCountry && this.selectedState) {
        this.cities = City.getCitiesOfState(
          this.selectedCountry.isoCode,
          this.selectedState.isoCode
        );

        // ✅ STEP 5: Set selectedCity
        this.selectedCity = this.location.city;
      }
    
      // this.selectedCity = this.user.address.adm_1
      // this.selectedCountry = this.user.address.country
      // this.selectedState = this.user.address.adm_2
    }
    if (this.user.emergencyContact) { 
      this.emergencyContact = {
        address: this.user.emergencyContact.address || '',
        fullName: this.user.emergencyContact.fullName || '',
        phoneNumber: this.user.emergencyContact.phoneNumber || '',
        relationship: this.user.emergencyContact.relationship || ''
      };    
    }
  } else {
    // If no user in localStorage, redirect to login
    this.$router.push("/login");
  }
  },
  methods: {

    loadUserFromLocalStorage() {
    const loggedInUser = localStorage.getItem("loggedInUser");
    if (!loggedInUser) return;

    this.user = JSON.parse(loggedInUser);

    if (this.user.address) {
      this.location = {
        address: this.user.address.name || '',
        lat: this.user.address.lat || '',
        long: this.user.address.lng || '',
        city: this.user.address.adm_1 || '',
        state: this.user.address.adm_2 || '',
        country: this.user.address.country || ''
      };
    }
  },

    async updateUser() {
      
      this.updatingUser = true;
  
      const payload = {
        user: {
          firstname: this.user.firstname,
          middlename: this.user.middlename,
          lastname: this.user.lastname,
          gender: this.user.gender,
          email: this.user.email,
          mobile_no: this.user.mobile_no,
          imageurl: this.user.imageurl,
          address: {
            name: this.location.address,
            lat: this.location.lat,
            lng: this.location.long,
            street_number: "",
            adm_1: this.location.city || "",
            adm_2: this.location.state || "",
            country: this.location.country || ""
          },
          emergencyContact: {
                address: this.emergencyContact.address,
                fullName: this.emergencyContact.fullName,
                phoneNumber: this.emergencyContact.phoneNumber,
                relationship: this.emergencyContact.relationship
            },
        },
      };

      try {
        let response = await this.$_saveAccountOwnerInformation(payload);

        this.$store.dispatch("saveUserDetails", response.data.data.user);
        this.generateToast("Your information has been updated!", "success");

        this.updatingUser = false;
        this.$router.push({ name: "AccountProfile" });
      } catch (error) {
        this.handleError(error);
        this.updatingUser = false;
      }
    },
  
    onImageUploaded(url) {
      this.uploadImage(url); 
    },
    
    async uploadImage(image) {
      this.isUploadingImage = true;

      const formData = new FormData();
      formData.append("file", image);
      formData.append("upload_preset", "zunt8yrw");

      try {
        const response = await this.$_uploadImage(formData);

         const imageUrl = response?.data?.fileUrl;

      if (!imageUrl) throw new Error("Upload failed: no URL returned");
        
        this.user.imageurl = imageUrl;  

        this.generateToast("Image uploaded", "success");
      } catch (error) {
        this.handleError(error);
      } finally {
        this.isUploadingImage = false;
      }
    },

    removeImage() {
      this.user.imageurl = null;
    },
  },
};
</script>

<style lang="scss" scoped>
.picture-upload-form {
  border-radius: 10px;
  padding: 1.55rem 1rem;
}
.picture-upload-form__img-wrapper {
  position: relative;
}
.user-img {
  width: 10rem;
  margin: 1.5rem auto;
} 
.upload-img-icon {
  position: absolute;
  right: 3.5rem;
  bottom: 1rem;
}
.picture-upload-form__meta {
  padding-top: 1rem;
}
.label {
  font-size: 0.9rem;
}
.input {
  margin-bottom: 0.5rem;
}
.new-user-form__col-three {
  padding-top: 1.25rem;
}
hr {
  margin: 2rem 0;
}

.input-row {
  width: 100%;
  display: flex;
}
.input-row > div {
  width: 100%;
  padding-right: 1rem;
}

.modal-input {
  background: #fafafd;
  border: 0.5px solid #c5d1e6;
  height: 2.75rem;
  border-radius: 4px;
  display: flex;

  input {
    border: none;
    background: transparent;
  }
  span {
    align-self: center;
    padding-right: 0.5rem;
    color: #747474;
    cursor: pointer;
  }
}
@media screen and (max-width: 768px) {
  .input-row {
    flex-direction: column;
  }
  .input-row div {
    width: 100%;
  }
}
</style>
